const BREAKPOINT = 1024;

function check() {
  return window.innerWidth < BREAKPOINT;
}

export default {
  data() {
    return {
      sdk: {
        mobile: check(),
      },
    };
  },
  mounted() {
    window.addEventListener('resize', this.sdkMobile);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.sdkMobile);
  },
  methods: {
    sdkMobile() {
      this.sdk.mobile = check();
    },
  },
};
